import { render, staticRenderFns } from "./TagAccordion.vue?vue&type=template&id=97414d30"
import script from "./TagAccordion.vue?vue&type=script&lang=ts"
export * from "./TagAccordion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports